// src/ui/components/ScoreBadge.tsx
import { colors } from "../design-system/colors";
import { fontFamily, typeScale } from "../design-system/typography";

export default function ScoreBadge({ score, size = 160 }: { score: number; size?: number }) {
  const radius = (size - 16) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, score));
  const dashOffset = circumference * (1 - clamped / 100);
  const center = size / 2;

  const color = clamped >= 80 ? colors.safe : clamped >= 55 ? colors.caution : colors.danger;

  return (
    <div style={{ position: "relative", width: size, height: size }}>
      <svg width={size} height={size}>
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke={colors.surfaceBorder}
          strokeWidth={10}
          fill="none"
        />
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke={color}
          strokeWidth={10}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          transform={`rotate(-90 ${center} ${center})`}
          style={{ transition: "stroke-dashoffset 0.6s ease-out" }}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: fontFamily.numeric,
        }}
      >
        <span style={{ fontSize: typeScale.readoutLarge.size, fontWeight: typeScale.readoutLarge.weight, color: colors.textPrimary }}>
          {Math.round(clamped)}
        </span>
        <span style={{ fontSize: typeScale.readoutSmall.size, color: colors.textSecondary, fontFamily: fontFamily.ui }}>
          / 100
        </span>
      </div>
    </div>
  );
}
